import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets, proxy } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },

    /**
     * Значения полей фильтра в меню кнопки фильтра по умолчанию для кнопки сброса.
     *
     * @returns {Object<string, undefined>} Пустое значение по имени поля.
     */
    defaultFilter() {
      return {
        ownerId: undefined
      }
    }
  },

  render
}
